import { useCallback, useEffect, useState } from 'react';
import SearchInput from '@components/common/SearchInput';
import {
    CorporationListItem,
    CorporationListReq,
    CorporationListRes,
} from '@/api/corporation/type';
import { api } from '@/api/corporation/api';
import SelectList from '@components/common/SelectList';

interface CorporationSelectListProps {
    onRowChange: (row: CorporationListItem) => void;
}

const CorporationSelectList = ({ onRowChange }: CorporationSelectListProps) => {
    const [corporationFilters, setCorporationFilters] =
        useState<CorporationListReq>(() => {
            return {
                pageSize: 10,
                nowPage: 1,
                pageGroup: 5,
                keyword: '',
                joinType: -1,
                userStatus: -1,
                startDt: undefined,
                endDt: undefined,
            };
        });

    const handleSearch = (value: string) => {
        updateCorporationFilters('keyword', value);
    };

    const handlePageChange = (page: number) => {
        updateCorporationFilters('nowPage', page);
    };

    const onCorporationClickRow = (row: CorporationListItem) => {
        onRowChange(row);
    };

    const updateCorporationFilters = (
        key: keyof CorporationListReq,
        value: any,
    ) => {
        setCorporationFilters(prev => ({
            ...prev,
            [key]: value,
            ...(key !== 'nowPage' && { nowPage: 1 }), // 페이지 외 필터 변경시 첫 페이지로
        }));
    };

    const [corporationRes, setCorporationListRes] =
        useState<CorporationListRes>();

    const fetchCorporation = useCallback(async () => {
        const response = await api.corporationList(corporationFilters);
        setCorporationListRes(response);
    }, [corporationFilters]);

    useEffect(() => {
        fetchCorporation();
    }, [fetchCorporation]);

    return (
        <>
            <div className="card custom-card">
                <div className="card-body">
                    <div className="row">
                        <div className="col-12">
                            <SearchInput
                                placeholder="대행사명을 입력해주세요."
                                value={corporationFilters.keyword || ''}
                                onSearch={handleSearch}
                            />
                        </div>
                    </div>
                    <div className="row ">
                        <div className="col-12">
                            {corporationRes && (
                                <SelectList
                                    title="대행사를 선택해주세요."
                                    data={corporationRes?.data}
                                    paging={corporationRes?.paging}
                                    onPageChange={handlePageChange}
                                    onClickRow={onCorporationClickRow}
                                />
                            )}
                        </div>
                    </div>
                </div>
            </div>
        </>
    );
};

export default CorporationSelectList;
